import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="relative bg-background-50 py-16 md:py-24 px-4 md:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-12 md:mb-16">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div>
              <p className="text-foreground-400 text-xs md:text-sm font-semibold uppercase tracking-[0.2em] mb-3">
                Navegue por Categoria
              </p>
              <h2 className="font-heading text-foreground-900 text-3xl md:text-4xl lg:text-5xl italic font-semibold">
                Encontre o que você precisa
              </h2>
            </div>
            <p className="text-foreground-500 text-sm md:text-base max-w-md leading-relaxed">
              Explore nossa seleção completa de produtos organizados por categoria. Cada link direciona para o catálogo completo no site principal.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat, index) => (
            <a
              key={cat.seq}
              href={cat.link}
              target="_blank"
              rel="noopener nofollow"
              className={`group block rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer relative ${
                index === 4
                  ? 'lg:bg-foreground-900 lg:hover:bg-foreground-800'
                  : 'bg-background-100 hover:bg-background-200/70'
              }`}
            >
              <div className="relative w-full h-52 md:h-60 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.namePt} - CSSBuy Spreadsheet categoria`}
                  title={`${cat.namePt} | CSSBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading={index < 6 ? 'eager' : 'lazy'}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span className={`inline-block px-3 py-1.5 rounded-full text-xs font-bold tracking-wide ${
                    index === 4
                      ? 'bg-accent-500/30 text-accent-200'
                      : 'bg-background-50/90 text-foreground-900'
                  }`}>
                    {cat.namePt}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className={`text-lg md:text-xl font-heading font-bold mb-2 ${
                  index === 4 ? 'text-background-50' : 'text-foreground-900'
                }`}>
                  Explore {cat.namePt}
                </h3>
                <p className={`text-sm leading-relaxed ${
                  index === 4 ? 'text-foreground-300' : 'text-foreground-500'
                }`}>
                  Veja todos os produtos da categoria {cat.namePt.toLowerCase()} disponíveis no CSSBuy Spreadsheet.
                </p>
                <div className="flex items-center gap-1.5 mt-4">
                  <span className={`text-sm font-medium ${
                    index === 4 ? 'text-accent-400' : 'text-foreground-700'
                  }`}>
                    Explorar
                  </span>
                  <i className={`ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform duration-300 ${
                    index === 4 ? 'text-accent-400' : 'text-foreground-700'
                  }`}></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}